module.exports = __webpack_public_path__ + "static/media/manage-alerts-icon.30be5a60.svg";